import { ErrorCode } from './constants';
import { TErrorText } from './types';

export const getErrorText = (errorCode: ErrorCode, count: number): TErrorText => {
  const ending = count !== 1 ? 's' : '';

  switch (errorCode) {
    case ErrorCode.RejectedBlank:
      return {
        title: `Can't create mockup with rejected blank`,
        description: 'Products can’t be created with rejected blanks. You can change list of blanks and try again'
      };

    case ErrorCode.NameNotUnique:
      return {
        title: `${count} Mockup${ending} will not be created`,
        description:
          'Products with the same name already exist. You can change the products or the artwork name, and try again'
      };

    case ErrorCode.MockupConfigurationMatches:
      return {
        title: `${count} selected blank${ending} already ${
          count !== 1 ? 'have' : 'has'
        } mockups with this artwork on the front panel`,
        description: 'Select for which blanks you wish to create additional mockups'
      };
  }
};

export const getNewIds = (blanksIds: string[], id: string, value: boolean): string[] => {
  if (value) {
    return [...blanksIds, id];
  } else {
    if (blanksIds.includes(id)) {
      return blanksIds.filter((blanksId) => blanksId !== id);
    } else {
      return blanksIds;
    }
  }
};
